import { FieldType, Schema } from "../../toolympus/hooks/useSchema";

/**
 * Represents a Contact entity in the CRM module.
 * Corresponds to table: crm_contact
 */
export interface Contact {
  /**
   * Primary Key
   * Type: UUID
   */
  _id: string;

  /**
   * Foreign Key to Space
   * Type: UUID
   */
  space_id: string;

  /**
   * Label: Имя
   */
  name: string;

  /**
   * Label: Email
   */
  email?: string;

  /**
   * Label: Телефон
   */
  phone?: string;

  /**
   * Label: Дата рождения
   * Format: YYYY-MM-DD
   */
  birth_date?: string;

  /**
   * Label: Заметки
   * Type: Powerdoc / JSON
   */
  notes?: Record<string, any>; 

  /**
   * Label: Теги
   * Default: []
   */
  tags: string[];

  /**
   * Custom fields
   * Default: ""
   */
  custom_text1?: string;
  custom_text2?: string;
  custom_text3?: string;
  custom_text4?: string;
  custom_text5?: string;

  /**
   * Label: Proximity
   * Type: Integer
   * Default: 0
   */
  proximity: number;

  /**
   * Audit fields
   */
  created_at: string; // ISO Date string
  created_by: number; // User ID (integer)

  updated_at?: string; // ISO Date string
  updated_by?: string; // User UUID
}


export const ContactSchema: Schema = {
  name: { type: FieldType.text, label: "Имя" },
  email: { type: FieldType.text, label: "Email" },
  phone: { type: FieldType.text, label: "Телефон" },
  birth_date: { type: FieldType.date, label: "Дата рождения" },
  notes: { type: FieldType.json, label: "Заметки" }, // Or FieldType.powerdoc if available
  tags: { type: FieldType.multiselect, label: "Теги" },
  custom_text1: { type: FieldType.text, label: "Поле 1" },
  custom_text2: { type: FieldType.text, label: "Поле 2" },
  custom_text3: { type: FieldType.text, label: "Поле 3" },
  custom_text4: { type: FieldType.text, label: "Поле 4" },
  custom_text5: { type: FieldType.text, label: "Поле 5" },
  proximity: { type: FieldType.number, label: "Proximity" },
};
